import InitMoreActionsDropdown from '~/milestones/init_more_actions_dropdown';

InitMoreActionsDropdown();
